import { render } from "./Orbitron.vue?vue&type=template&id=24f42aa8"
import script from "./Orbitron.vue?vue&type=script&lang=js"
export * from "./Orbitron.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__